import type { EliteOnboardingStatusResponse } from '../../types/misc.types'

type EligiblePlan = EliteOnboardingStatusResponse['eligiblePlans'][number]

export function isYearlyPlanTenure(
  tenure: EligiblePlan['effectivePlanTenure'] | EligiblePlan['basePlanTenure'] | undefined
): boolean {
  if (tenure?.period === 'YEAR') return true
  const tenureValue = Number(tenure?.value ?? 0)
  if (tenure?.period === 'MONTH') return tenureValue >= 12
  if (tenure?.period === 'DAY') return tenureValue >= 12
  return false
}
